import React, {useEffect, useMemo, useRef, RefObject, useCallback, Component} from 'react';
import $ from 'jquery';
import _ from 'lodash';
import 'select2';

interface ISelect {
    matcher: boolean;
    value?: string;
    className: string;
    placeholder?: string;
    name: string;
    onChange: (k: string, v: string) => void;
}

class Select extends Component<ISelect>{
    select: RefObject<HTMLSelectElement>;

    constructor(props: ISelect) {
        super(props);

        this.select = React.createRef();
    }

    initSelect2(){
        if(!this.select.current)
            return;

        $(this.select.current).select2({
            width:'100%',
            placeholder: this.props.placeholder || '',
            matcher: this.props.matcher ? this.matcher : undefined
        });
        this.select.current.onchange = this.handleOnChange;
    }

    componentDidMount(): void {
        if(!this.select.current)
            return;

        this.initSelect2();
    }
    componentDidUpdate(prevProps: Readonly<ISelect>, prevState: Readonly<{}>, snapshot?: any): void {
        if(!this.select.current)
            return;

        $(this.select.current).select2('destroy');
        this.initSelect2();
    }

    componentWillUnmount(): void {
        if(!this.select.current)
            return;

        $(this.select.current).select2('destroy');
    }

    private matcher = ({term=''},data)=> {
        if(!term.trim())
            return data;

        const {text, title, element} = data;
        const lowerTerm = _.deburr(term).toLowerCase().normalize("NFD")

        if (element.dataset.matchtext) {
            let matchText = element.dataset.matchtext as String
            matchText = matchText.trim().normalize("NFD").toLowerCase()
            if (matchText.includes(lowerTerm)) {
                return data
            }
        }

        if(_.deburr(text).toLowerCase().includes(lowerTerm) || _.deburr(title).toLowerCase().includes(lowerTerm))
            return data;

        return false;
    }
    private handleOnChange = (event) => {
        if (this.props.onChange)
            this.props.onChange(event.target.name, event.target.value);
    }



    render() {
        const {className, name, value} = this.props;
        return <select ref={this.select} className={className} name={name} value={value} onChange={this.handleOnChange}>
            {!value && <option key={-1}/>}
            {this.props.children}
        </select>
    }
}

export default Select
